import * as _ from "lodash";

export default function Memoize(): MethodDecorator {
    return function (target: Object, key: string | symbol, descriptor: PropertyDescriptor) {
        if(descriptor === undefined) {
            descriptor = Object.getOwnPropertyDescriptor(target, key);
        }
        var originalMethod = descriptor.value;
    
        var memoized = _.memoize(originalMethod);
        descriptor.value = memoized;
    }
}